<amplify-authenticator>
    <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
        <div class="userPage">

            <!-- bootstap table display user info-->
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">{{'Email' | i18n}}</th>
                        <!-- <th scope="col">{{'Type' | i18n}}</th> -->
                        <th scope="col">{{'Token' | i18n}}</th>
                        <th scope="col">{{'Action' | i18n}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{user.attributes.email}}</td>
                        <!-- <td>
                            <button class="btn btn-primary" (click)="openChangeTokenTypeModal(content)">{{tokenType |
                                i18n}}</button>
                        </td> -->
                        <td><button class="btn btn-outline-black" [cdkCopyToClipboard]="token?.uuid ??''">{{token?.uuid}}</button></td>
                        <td>
                            <button class="btn btn-primary" (click)="signOut()">{{'Sign Out' | i18n}}</button>

                        </td>
                    </tr>
                </tbody>
            </table>


<!-- 
            <user-payment-sum [userBillingStatus]="userBillingStatus" [tokenType]="tokenType"
                [(loadingFlag)]="loadingFlag" (loadingFlagChange)="loadingFlag = $event"></user-payment-sum>
            <div style="font-size: 60%;">{{token?.owner}}</div> -->
        </div>
    </ng-template>
</amplify-authenticator>

<!-- <ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-change-token-type">{{'Choose Token Type' | i18n}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="mb-3">
            <mat-radio-group [(ngModel)]="tokenType" aria-label="Select an option">
                <mat-radio-button value="subscription">{{'Subscription'|i18n}} </mat-radio-button>
                <mat-radio-button value="topUp">{{'TopUp'|i18n}}</mat-radio-button>
            </mat-radio-group>

            <div *ngIf="tokenType == 'subscription'">
                {{'Monthly Subscription Price'|i18n}} <b>200</b> {{'NIS'|i18n}}
                <ul>
                    <li> {{'Parse Invoice'|i18n}} <b>0.05</b> {{'NIS'|i18n}} </li>
                    <li> {{'Other Documents'|i18n}} <b>0.50</b> {{'NIS'|i18n}} </li>
                </ul>
                <div><b>{{'Note: If the API is not in use, there will be no monthly fee.'| i18n}}</b></div>
            </div>
            <div *ngIf="tokenType == 'topUp'">
                {{'Monthly Subscription Price'|i18n}} <b>0</b> {{'NIS'|i18n}}
                <ul>
                    <li> {{'Parse Invoice'|i18n}} <b>0.10</b> {{'NIS'|i18n}} </li>
                    <li> {{'Other Documents'|i18n}} <b>1.00</b> {{'NIS'|i18n}} </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">{{'Save'|i18n}}</button>
    </div>
</ng-template> -->

<hr />

<div id="loader" *ngIf="loadingFlag"></div>